import { computed } from 'mobx';

export default class TopicModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.updateFromJson(item);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      name: this.name,
      description: this.description,
      caption: this.caption,
      type: this.type,
      options: this.options || [],
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.name = json.name;
    this.description = json.description;
    this.caption = json.caption;
    this.type = json.type;
    this.options = json.options || [];
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Survey/TopicModel.js